import { StrictMode } from "react";
import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { StateContextProvider } from "./middleware/context/state-context-provider";
import { StandardViewer } from "./components/viewer/standard-viewer";
import { Home } from "./components/public/home-page";
import { Dashboard } from "./components/user/dashboard-page";
import { AuthenticationAndRegisteration } from "./components/user/authentication-registeration";
import "./styles/global.css";
import { FourDimensionViewer } from "./components/viewer/4d-viewer";
import { MapViewer } from "./components/viewer/map-viewer";
import { PrivacyPolicy } from "./components/public/privacy-policy";
import { Charvue } from "./components/public/product/charvue";
import { Charsync } from "./components/public/product/charsync";
import { ProjectPage } from "./components/user/project-page";
import { Products } from "./components/public/products-page";
import { Pricing } from "./components/public/pricing-page";
import { AboutUs } from "./components/public/about-us-page";
import { Services } from "./components/public/services-page";
import { ContactUs } from "./components/public/contact-us-page";
import { ReportViewer } from "./components/viewer/report-viewer";
import { PdfViewer } from "./components/viewer/pdf-viewer";
import { LocationHandler } from "./middleware/handlers/location-handler";

function App() {
  return (
    <StrictMode>
      <StateContextProvider>
        <Router>
          <LocationHandler />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/AUTHENTICATION&REGISTRATION"
              element={<AuthenticationAndRegisteration />}
            />
            <Route path="/DASHBOARD/*" element={<Dashboard />} />
            <Route path="/PROJECT" element={<ProjectPage />} />
            <Route path="/STANDARD" element={<StandardViewer />} />
            <Route path="/4D" element={<FourDimensionViewer />} />
            <Route path="/MAP" element={<MapViewer />} />
            <Route path="/PDF" element={<PdfViewer />} />
            <Route path="/PRIVACY_POLICY" element={<PrivacyPolicy />} />
            <Route path="/ABOUT_US" element={<AboutUs />} />
            <Route path="/CONTACT_US" element={<ContactUs />} />
            <Route path="/SERVICES" element={<Services />} />
            <Route path="/PRODUCTS" element={<Products />} />
            <Route path="/PRICING" element={<Pricing />} />
            <Route path="/PRODUCTS/CHARVUE" element={<Charvue />} />
            <Route
              path="/PRODUCTS/NCRP"
              element={<Navigate to="/products/charvue" replace />}
            />
            <Route path="/PRODUCTS/CHARSYNC" element={<Charsync />} />
            <Route path="/REPORT_VIEWER" element={<ReportViewer />} />
          </Routes>
        </Router>
      </StateContextProvider>
    </StrictMode>
  );
}

export default App;
